var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-sheet-field',{attrs:{"align":"center","is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[(_vm.value)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatcurrency(_vm.value))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }